export default "__VITE_ASSET__nnCZQSOD__"